import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ReportsPage, type ReportTab } from "@/components/reports/ReportsPage";

const VALID_TABS = ["timesheet", "leave", "ot"] as const satisfies readonly ReportTab[];

export const Route = createFileRoute("/admin/_layout/reports")({
  validateSearch: z.object({ tab: z.enum(VALID_TABS).catch("timesheet").default("timesheet") }),
  component: AdminReports,
});

function AdminReports() {
  const { tab } = Route.useSearch();
  return <ReportsPage activeTab={tab} />;
}
